function isBlockedShortcut(event) {
  const key = event.key?.toLowerCase()
  const ctrlOrMeta = event.ctrlKey || event.metaKey

  if (key === 'f12') return true
  if (ctrlOrMeta && event.shiftKey && ['i', 'j', 'c'].includes(key)) return true
  if (ctrlOrMeta && !event.shiftKey && !event.altKey && key === 'u') return true
  if (event.metaKey && event.altKey && ['i', 'j', 'c', 'u'].includes(key)) return true
  if (ctrlOrMeta && ['c', 'a', 's'].includes(key)) return true

  return false
}

export function attachContentProtection(rootEl) {
  if (!rootEl) return () => {}

  const onDragStart = (event) => {
    if (event.target?.tagName === 'IMG') {
      event.preventDefault()
    }
  }

  const onKeyDown = (event) => {
    if (isBlockedShortcut(event)) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  const blockClipboard = (event) => {
    event.preventDefault()
  }

  rootEl.addEventListener('dragstart', onDragStart)
  rootEl.addEventListener('copy', blockClipboard)
  rootEl.addEventListener('cut', blockClipboard)
  rootEl.addEventListener('selectstart', blockClipboard)
  document.addEventListener('keydown', onKeyDown, true)

  rootEl.querySelectorAll('img').forEach((img) => {
    img.setAttribute('draggable', 'false')
  })

  return () => {
    rootEl.removeEventListener('dragstart', onDragStart)
    rootEl.removeEventListener('copy', blockClipboard)
    rootEl.removeEventListener('cut', blockClipboard)
    rootEl.removeEventListener('selectstart', blockClipboard)
    document.removeEventListener('keydown', onKeyDown, true)
  }
}
